// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SubscriptionConfig,
  SubscriptionConfigT,
  verifySubscriptionConfig,
} from "./subscription-config";

/**
 * A named subscription with its own settings. Monitored items whose
 * SubscribeMode names this subscription are grouped under it.
 */
export class NamedSubscription implements flatbuffers.IUnpackableObject<NamedSubscriptionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NamedSubscription {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNamedSubscription(
    bb: flatbuffers.ByteBuffer,
    obj?: NamedSubscription,
  ): NamedSubscription {
    return (obj || new NamedSubscription()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNamedSubscription(
    bb: flatbuffers.ByteBuffer,
    obj?: NamedSubscription,
  ): NamedSubscription {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NamedSubscription()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  config(obj?: SubscriptionConfig): SubscriptionConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new SubscriptionConfig()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  static startNamedSubscription(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addConfig(builder: flatbuffers.Builder, configOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, configOffset, 0);
  }

  static endNamedSubscription(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // name
    builder.requiredField(offset, 6); // config
    return offset;
  }

  unpack(): NamedSubscriptionT {
    return new NamedSubscriptionT(
      this.name(),
      this.config() !== null ? this.config()!.unpack() : null,
    );
  }

  unpackTo(_o: NamedSubscriptionT): void {
    _o.name = this.name();
    _o.config = this.config() !== null ? this.config()!.unpack() : null;
  }

  unpackFields(...fields: string[]): NamedSubscriptionT {
    const t = new NamedSubscriptionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("config")) {
      t.config = this.config() !== null ? this.config()!.unpack() : null;
    }
    return t;
  }
}

export class NamedSubscriptionT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public config: SubscriptionConfigT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    if (this.config === null || this.config === undefined) {
      throw new Error('Required field "config" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const config = this.config !== null ? this.config!.pack(builder) : 0;

    NamedSubscription.startNamedSubscription(builder);
    NamedSubscription.addName(builder, name);
    NamedSubscription.addConfig(builder, config);

    return NamedSubscription.endNamedSubscription(builder);
  }

  clone(): NamedSubscriptionT {
    const obj = new NamedSubscriptionT();
    obj.name = this.name;
    obj.config = this.config !== null ? this.config!.clone() : null;
    return obj;
  }

  equals(other: NamedSubscriptionT): boolean {
    if (this.name !== other.name) return false;
    if (this.config !== null && other.config !== null) {
      if (!this.config!.equals(other.config!)) return false;
    } else if (this.config !== other.config) return false;
    return true;
  }
}

export function verifyNamedSubscription(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "name");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifySubscriptionConfig(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "config");
  } finally {
    verifier.popDepth();
  }
}
